export const CONSONANT_VOWEL_PAIRS_PP = [

    // ㅃ
    {
        id: 1,
        korean: "빠",
        english: "ppa",

    },
    {
        id: 2,
        korean: "뻬",
        english: "ppe",

    },
    {
        id: 3,
        korean: "삐",
        english: "ppi",

    },
    {
        id: 4,
        korean: "뽀",
        english: "ppo",

    },
    {
        id: 5,
        korean: "쁘",
        english: "ppeu",

    },
    {
        id: 6,
        korean: "뻐",
        english: "ppeo",

    },
    {
        id: 7,
        korean: "뺘",
        english: "ppya",

    },
    {
        id: 8,
        korean: "빼",
        english: "ppae",

    },
    {
        id: 9,
        korean: "뼤",
        english: "ppye",

    },
    {
        id: 10,
        korean: "뾰",
        english: "ppyo",

    },
    {
        id: 11,
        korean: "뼈",
        english: "ppyeo",

    },
    {
        id: 12,
        korean: "쀼",
        english: "ppyu",

        

    },

    {
        id: 13,
        korean: "빤",
        english: "ppan",

        

    },
    {
        id: 14,
        korean: "빡",
        english: "ppak",

        

    },
    {
        id: 15,
        korean: "삠",
        english: "ppim",
        

    },
    {
        id: 16,
        korean: "빹",
        english: "ppat",
        

    },
    {
        id: 17,
        korean: "빻",
        english: "ppah",
        

    },
    {
        id: 18,
        korean: "뻡",
        english: "ppeob",
        

    },
          {
        id: 19,
        korean: "쁠",
        english: "ppeul",
        

    },
    {
        id: 20,
        korean: "빳",
        english: "ppat",
        

    },
    {
        id: 21,
        korean: "빾",
        english: "ppaekk",
        

    },
    {
        id: 22,
        korean: "뺀",
        english: "ppaen",
        

    },
    {
        id: 23,
        korean: "쁴",
        english: "ppui",
        

    },
    {
        id: 24,
        korean: "뿨",
        english: "ppwo",
        

    },

    {
        id: 25,
        korean: "뺱",
        english: "ppyat",
        

    },
    {
        id: 26,
        korean: "빷",
        english: "ppat",
        

    },
    {
        id: 27,
        korean: "빵",
        english: "ppang",
        
    }
    
];

